var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 56,
    viewBox: "0 0 151 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150.249,
    height: 56,
    rx: 8.45283,
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2717_10062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 14.1809C14.6704 14.5258 14.4785 15.0612 14.4785 15.7545V40.5244C14.4785 41.2188 14.6704 41.753 14.9951 42.098L15.0776 42.1786L28.8993 28.303V28.1394V27.9759L15.0776 14.0991L14.9951 14.1809Z",
    fill: "url(#paint0_linear_2717_10062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5049 32.929L28.8984 28.3022V28.1387V27.9752L33.5061 23.3496L33.6098 23.409L39.0687 26.5226C40.6272 27.4118 40.6272 28.8667 39.0687 29.7571L33.6098 32.8707L33.5049 32.929Z",
    fill: "url(#paint1_linear_2717_10062)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2717_10062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6098 32.8696L28.8973 28.1387L14.9941 42.0972C15.5073 42.6438 16.3563 42.711 17.3125 42.1667L33.6098 32.8696Z",
    fill: "url(#paint2_linear_2717_10062)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.6098 23.4082L17.3125 14.1122C16.3563 13.5668 15.5073 13.6351 14.9941 14.1817L28.8984 28.1402L33.6098 23.4082Z",
    fill: "url(#paint3_linear_2717_10062)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2948 29.4941C72.8165 29.4941 70.7966 31.3782 70.7966 33.9732C70.7966 36.5524 72.8165 38.4522 75.2948 38.4522C77.7741 38.4522 79.794 36.5524 79.794 33.9732C79.793 31.3782 77.7731 29.4941 75.2948 29.4941ZM75.2948 36.6893C73.9366 36.6893 72.7659 35.5698 72.7659 33.9742C72.7659 32.3618 73.9376 31.2592 75.2948 31.2592C76.653 31.2592 77.8236 32.3618 77.8236 33.9742C77.8236 35.5687 76.653 36.6893 75.2948 36.6893ZM65.4807 29.4941C63.0024 29.4941 60.9825 31.3782 60.9825 33.9732C60.9825 36.5524 63.0024 38.4522 65.4807 38.4522C67.96 38.4522 69.98 36.5524 69.98 33.9732C69.98 31.3782 67.96 29.4941 65.4807 29.4941ZM65.4807 36.6893C64.1225 36.6893 62.9518 35.5698 62.9518 33.9742C62.9518 32.3618 64.1236 31.2592 65.4807 31.2592C66.8389 31.2592 68.0096 32.3618 68.0096 33.9742C68.0106 35.5687 66.8389 36.6893 65.4807 36.6893ZM53.8079 30.8695V32.7694H58.3578C58.2218 33.8384 57.8657 34.6188 57.322 35.1611C56.6603 35.8225 55.6245 36.5523 53.8079 36.5523C51.0072 36.5523 48.8176 34.2954 48.8176 31.4961C48.8176 28.6969 51.0072 26.4399 53.8079 26.4399C55.3189 26.4399 56.4221 27.0339 57.2366 27.7975L58.578 26.4568C57.44 25.371 55.9301 24.54 53.8079 24.54C49.9714 24.54 46.7461 27.6616 46.7461 31.4961C46.7461 35.3307 49.9714 38.4522 53.8079 38.4522C55.8784 38.4522 57.4411 37.773 58.6623 36.5007C59.9183 35.2454 60.3092 33.4803 60.3092 32.0554C60.3092 31.6151 60.2755 31.2076 60.207 30.8685L53.8079 30.8695ZM101.549 32.345C101.176 31.3445 100.038 29.4941 97.712 29.4941C95.4034 29.4941 93.4846 31.3097 93.4846 33.9732C93.4846 36.4839 95.3866 38.4522 97.9323 38.4522C99.9859 38.4522 101.174 37.1969 101.668 36.467L100.14 35.4486C99.6308 36.1953 98.9343 36.6872 97.9323 36.6872C96.9313 36.6872 96.2179 36.229 95.7596 35.3296L101.752 32.8526L101.549 32.345ZM95.4371 33.8384C95.3866 32.107 96.7785 31.2255 97.7805 31.2255C98.5613 31.2255 99.223 31.6162 99.4443 32.1754L95.4371 33.8384ZM90.5659 38.1816H92.5342V25.0161H90.5659V38.1816ZM87.3395 30.4956H87.2721C86.8306 29.9691 85.9813 29.4941 84.9129 29.4941C82.6717 29.4941 80.618 31.4624 80.618 33.9911C80.618 36.5018 82.6717 38.4533 84.9129 38.4533C85.9824 38.4533 86.8306 37.9783 87.2721 37.4359H87.3395V38.0805C87.3395 39.794 86.4228 40.7102 84.9466 40.7102C83.7412 40.7102 82.9941 39.8456 82.6885 39.1157L80.9742 39.8287C81.4662 41.0156 82.7728 42.4753 84.9466 42.4753C87.2552 42.4753 89.2077 41.1178 89.2077 37.8088V29.7669H87.3406L87.3395 30.4956ZM85.0825 36.6893C83.7243 36.6893 82.5874 35.5519 82.5874 33.9911C82.5874 32.4124 83.7243 31.2592 85.0825 31.2592C86.4228 31.2592 87.4754 32.4124 87.4754 33.9911C87.4754 35.5519 86.4228 36.6893 85.0825 36.6893ZM110.773 25.0161H106.061V38.1816H108.027V33.1938H110.771C112.951 33.1938 115.094 31.6173 115.094 29.1055C115.094 26.5937 112.952 25.0161 110.773 25.0161ZM110.823 31.3613H108.027V26.8486H110.823C112.293 26.8486 113.128 28.065 113.128 29.1055C113.128 30.1249 112.293 31.3613 110.823 31.3613ZM122.974 29.4709C121.551 29.4709 120.077 30.0976 119.467 31.4867L121.211 32.2144C121.584 31.4867 122.28 31.2487 123.008 31.2487C124.025 31.2487 125.058 31.8584 125.075 32.9421V33.078C124.719 32.8747 123.956 32.5704 123.025 32.5704C121.144 32.5704 119.228 33.6035 119.228 35.5339C119.228 37.2959 120.771 38.4301 122.499 38.4301C123.82 38.4301 124.55 37.8372 125.007 37.1421H125.074V38.1584H126.973V33.1106C126.974 30.7747 125.227 29.4709 122.974 29.4709ZM122.736 36.6861C122.093 36.6861 121.195 36.3638 121.195 35.5676C121.195 34.5514 122.314 34.1617 123.28 34.1617C124.143 34.1617 124.551 34.3481 125.075 34.6019C124.923 35.8225 123.872 36.6861 122.736 36.6861ZM133.887 29.7584L131.634 35.4665H131.566L129.227 29.7584H127.109L130.617 37.7361L128.617 42.1741H130.667L136.074 29.7584H133.887ZM116.179 38.1816H118.144V25.0161H116.179V38.1816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5617 17.2289C53.5617 18.0955 53.3007 18.7852 52.7774 19.3002C52.1837 19.9123 51.4089 20.2184 50.4572 20.2184C49.5455 20.2184 48.7696 19.9082 48.1327 19.2877C47.4948 18.6663 47.1758 17.8969 47.1758 16.9787C47.1758 16.0594 47.4948 15.29 48.1327 14.6696C48.7696 14.0481 49.5455 13.7379 50.4572 13.7379C50.9099 13.7379 51.3426 13.8247 51.7531 13.9974C52.1647 14.1711 52.4943 14.4017 52.7406 14.6902L52.1858 15.2362C51.7679 14.7451 51.192 14.5 50.4561 14.5C49.7908 14.5 49.216 14.7295 48.7307 15.1887C48.2454 15.6478 48.0032 16.2445 48.0032 16.9776C48.0032 17.7108 48.2454 18.3074 48.7307 18.7666C49.216 19.2257 49.7908 19.4553 50.4561 19.4553C51.1615 19.4553 51.75 19.2247 52.2205 18.7624C52.5258 18.4615 52.7027 18.0427 52.7501 17.506H50.4561V16.7605H53.5165C53.5481 16.9228 53.5617 17.079 53.5617 17.2289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.415 14.6376H55.5389V16.6044H58.1329V17.3499H55.5389V19.3168H58.415V20.0799H54.7272V13.8755H58.415V14.6376Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8374 20.0799H61.0257V14.6376H59.2613V13.8755H63.6018V14.6376H61.8374V20.0799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7421 20.0799V13.8755H67.5537V20.0799H66.7421Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1533 20.0799H70.3416V14.6376H68.5772V13.8755H72.9177V14.6376H71.1533V20.0799Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1341 19.2785C80.513 19.9051 79.7413 20.2185 78.8181 20.2185C77.8948 20.2185 77.1231 19.9051 76.5031 19.2785C75.882 18.6518 75.5724 17.8846 75.5724 16.9777C75.5724 16.0708 75.882 15.3035 76.5031 14.6768C77.1231 14.0502 77.8948 13.7358 78.8181 13.7358C79.7361 13.7358 80.5067 14.0512 81.1299 14.681C81.7531 15.3107 82.0647 16.076 82.0647 16.9777C82.0647 17.8846 81.7542 18.6518 81.1341 19.2785ZM77.1021 18.7583C77.5695 19.2237 78.1411 19.4553 78.8181 19.4553C79.495 19.4553 80.0677 19.2226 80.534 18.7583C81.0015 18.293 81.2362 17.6995 81.2362 16.9777C81.2362 16.2559 81.0015 15.6623 80.534 15.197C80.0677 14.7317 79.495 14.5 78.8181 14.5C78.1411 14.5 77.5695 14.7327 77.1021 15.197C76.6357 15.6623 76.401 16.2559 76.401 16.9777C76.401 17.6995 76.6357 18.293 77.1021 18.7583Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2038 20.0799V13.8755H84.1913L87.2611 18.7015H87.2959L87.2611 17.5061V13.8755H88.0728V20.0799H87.2253L84.0134 15.0191H83.9787L84.0134 16.2145V20.0799H83.2038Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5617 17.2289C53.5617 18.0955 53.3007 18.7852 52.7774 19.3002C52.1837 19.9123 51.4089 20.2184 50.4572 20.2184C49.5455 20.2184 48.7696 19.9082 48.1327 19.2877C47.4948 18.6663 47.1758 17.8969 47.1758 16.9787C47.1758 16.0594 47.4948 15.29 48.1327 14.6696C48.7696 14.0481 49.5455 13.7379 50.4572 13.7379C50.9099 13.7379 51.3426 13.8247 51.7531 13.9974C52.1647 14.1711 52.4943 14.4017 52.7406 14.6902L52.1858 15.2362C51.7679 14.7451 51.192 14.5 50.4561 14.5C49.7908 14.5 49.216 14.7295 48.7307 15.1887C48.2454 15.6478 48.0032 16.2445 48.0032 16.9776C48.0032 17.7108 48.2454 18.3074 48.7307 18.7666C49.216 19.2257 49.7908 19.4553 50.4561 19.4553C51.1615 19.4553 51.75 19.2247 52.2205 18.7624C52.5258 18.4615 52.7027 18.0427 52.7501 17.506H50.4561V16.7605H53.5165C53.5481 16.9228 53.5617 17.079 53.5617 17.2289Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.415 14.6376H55.5389V16.6044H58.1329V17.3499H55.5389V19.3168H58.415V20.0799H54.7272V13.8755H58.415V14.6376Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8374 20.0799H61.0257V14.6376H59.2613V13.8755H63.6018V14.6376H61.8374V20.0799Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7421 20.0799V13.8755H67.5537V20.0799H66.7421Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1533 20.0799H70.3416V14.6376H68.5772V13.8755H72.9177V14.6376H71.1533V20.0799Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1341 19.2785C80.513 19.9051 79.7413 20.2185 78.8181 20.2185C77.8948 20.2185 77.1231 19.9051 76.5031 19.2785C75.882 18.6518 75.5724 17.8846 75.5724 16.9777C75.5724 16.0708 75.882 15.3035 76.5031 14.6768C77.1231 14.0502 77.8948 13.7358 78.8181 13.7358C79.7361 13.7358 80.5067 14.0512 81.1299 14.681C81.7531 15.3107 82.0647 16.076 82.0647 16.9777C82.0647 17.8846 81.7542 18.6518 81.1341 19.2785ZM77.1021 18.7583C77.5695 19.2237 78.1411 19.4553 78.8181 19.4553C79.495 19.4553 80.0677 19.2226 80.534 18.7583C81.0015 18.293 81.2362 17.6995 81.2362 16.9777C81.2362 16.2559 81.0015 15.6623 80.534 15.197C80.0677 14.7317 79.495 14.5 78.8181 14.5C78.1411 14.5 77.5695 14.7327 77.1021 15.197C76.6357 15.6623 76.401 16.2559 76.401 16.9777C76.401 17.6995 76.6357 18.293 77.1021 18.7583Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2038 20.0799V13.8755H84.1913L87.2611 18.7015H87.2959L87.2611 17.5061V13.8755H88.0728V20.0799H87.2253L84.0134 15.0191H83.9787L84.0134 16.2145V20.0799H83.2038Z",
    stroke: "white",
    strokeWidth: 0.0432175,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2717_10062",
    x: 14.4785,
    y: 13.7358,
    width: 25.7598,
    height: 28.8066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2717_10062"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2717_10062",
    result: "effect2_innerShadow_2717_10062"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2717_10062",
    x: 14.9941,
    y: 28.1387,
    width: 18.6152,
    height: 14.4038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2717_10062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2717_10062",
    x1: 27.6741,
    y1: 15.4924,
    x2: 8.87845,
    y2: 34.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2717_10062",
    x1: 41.0975,
    y1: 28.1387,
    x2: 14.1034,
    y2: 28.1387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2717_10062",
    x1: 31.0506,
    y1: 30.7078,
    x2: 5.5613,
    y2: 56.0981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2717_10062",
    x1: 11.4926,
    y1: 5.93602,
    x2: 22.8743,
    y2: 17.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAppIcon);
export default __webpack_public_path__ + "static/media/google-app-icon.7b683e5c6b708bc4a667ac52da775877.svg";
export { ForwardRef as ReactComponent };